import create from 'zustand';

import Etsy from 'Models/Etsy';

const [useEtsyStore] = create((set) => ({
	inventory: null,
	countries: null,
	connectEtsy: async (params) => {
		console.log('connect etsy');
		const response = await Etsy.connect(params);

		console.log('response etsy', response);

		if (response.loginUrl) {
			window.location.href = response.loginUrl;
		}
	},
	getInventory: async (params) => {
		console.log('call etsy getInventory');
		const response = await Etsy.getInventory(params);

		console.log('response etsy', response);
		set({ inventory: response });
	},
	getCountries: async (params) => {
		console.log('call etsy getCountries');
		const response = await Etsy.getCountries(params);

		console.log('response etsy', response);
		set({ countries: response });
	},
	getTransactions: async (params) => {
		console.log('call etsy getTransactions');
		const response = await Etsy.getTransactions(params);

		console.log('response etsy', response);
	},
	getOrder: async (params) => {
		console.log('call etsy getOrder');
		const response = await Etsy.getOrder(params);

		console.log('response etsy', response);
	}
}));

export default useEtsyStore;
